<template>
  <div class="fpds-Form-item u-marginBottomNone">
    <div class="fpds-Form-itemControl" :class="{ 'has-error': hasInvalidCountry }">
      <label for="country" class="fpds-Form-itemLabel fpds-FieldLabel">{{
        $t("country.label")
      }}</label>
      <div class="fpds-Select">
        <select
          id="country"
          v-model="valueCopy"
          class="fpds-Select-control"
          :class="{ 'u-textMuted': !valueCopy, 'u-fontItalic': !valueCopy }"
          autocomplete=""
          @blur="hasInvalidCountry = valueCopy && !validateCountry(valueCopy)"
          :disabled="disabled"
        >
          <option value disabled selected hidden>
            {{ $t("country.placeholder") }}
          </option>
          <option v-for="c in sortedCountries" :key="c['alpha-2']" :value="c['alpha-2']">
            {{ c.name }}
          </option>
        </select>
      </div>
      <div class="fpds-Form-itemError">
        <div v-if="hasInvalidCountry">
          {{ $t("country.errors.invalid-country") }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import countries from "../config/countries";

export default {
  name: "CountrySelector",
  props: {
    value: { type: String, required: true },
    disabled: { type: Boolean, default: false },
  },
  data: () => {
    return {
      hasInvalidCountry: false,
      countries: countries,
    };
  },
  computed: {
    valueCopy: {
      get() {
        return this.value;
      },
      set(value) {
        this.value = value;
        this.$emit("input", value);
        this.$emit("on-change", value);
      },
    },
    sortedCountries() {
      return [...this.countries].sort((a, b) => a.name.localeCompare(b.name));
    },
  },
  methods: {
    validateCountry(country) {
      return country?.trim().length ?? 0 > 0;
    },
  },
};
</script>
